export const checkIfStudentIsOnEvent = (event, student) => {
  let studentIsOnEvent = student.studentSchool === event.school;
  return studentIsOnEvent;
};